import { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '../config/api';
import { getStoredUser } from './auth';

/** Load all companies for super-admin mapping dropdowns (Create Client, Create User, etc.). */
export function useAdminCompanies({ enabled = true } = {}) {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    const actor = getStoredUser();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(apiUrl('/api/admin/companies'), {
        headers: {
          'Content-Type': 'application/json',
          'X-User-Email': actor?.email || '',
        },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setCompanies([]);
        setError(data.detail || 'Failed to load companies');
        return [];
      }
      const loaded = data.companies || [];
      setCompanies(loaded);
      return loaded;
    } catch {
      setCompanies([]);
      setError('Could not reach API');
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    reload();
    return undefined;
  }, [enabled, reload]);

  return { companies, loading, error, reload };
}
